import { makeStyles } from "tss-react/mui";

export const useStyles =  makeStyles()((theme) => ({
    root: { 
        display:"flex", 
        flexDirection: "column",
        gap: theme.spacing(5),
        paddingTop: theme.spacing(3), // 🔹 space below navigation bar
    }, 
    logoContainer:{
        height: "6.73vh",  
        display: 'flex', 
        justifyContent: "center", 
        alignItems: "center",
        gap: theme.spacing(),
        "@media(min-width: 1536px)": { 
            height: "6.8vh",
        },
        "@media(min-width: 1920px)": {
            height: "6.75vh",
            margin: "0 auto",         // 🔹 keeps centered alignment
            marginTop: theme.spacing(4), // 🔹 consistent padding from navbar
        },
    }, 
    logoImage: {
        width:"50.46px",
        height: "42px",
        fontSize: "50.46px",
    },
    logoText: {
        fontSize: "34px", 
        fontWeight: 500, 
        color: "var(--color-neutral-white)",
        lineHeight: "110%",
        letterSpacing: "0%",
    },
    container: {
        display: "flex", 
        justifyContent: "stretch", 
        alignItems: "stretch",
        gap: theme.spacing(4),
        flexDirection:"row", 
        height: "37.82vh",  
        paddingBottom: 0,
        "@media(min-width: 1536px)": { 
            height: "37.98vh", 
            paddingBottom: 0,
        },
        "@media(min-width: 1920px)": { 
            height: "38.56vh",
            paddingBottom: theme.spacing(7),
        },
    }, 
    box: {
        borderWidth: 1,
        borderColor: "var(--color-neutral-500)", 
        backgroundColor: "var(--color-neutral-white)",
        borderStyle: "solid", 
        borderRadius: theme.spacing(1.25),
        boxShadow: '0px 4px 20px 0px #EBF1FF',
        width: "50%", 
        paddingTop: theme.spacing(2.5),
        paddingBottom: theme.spacing(2.5),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4), 
        position:"relative"
    }, 
    boxHeader: {
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center"
    }, 
    title: {
        fontWeight: 600, 
        fontSize: theme.spacing(2.25),
        color:"var(--color-neutral-800)", 
        lineHeight: "160%"
    },
    listContainer : {
        display: "table",   
        borderCollapse:"separate",
        borderSpacing: "0px",
        width:"100%",
        maxWidth: "100%", 
        tableLayout: "fixed",
        "& .list-item": { 
            display: "table-row",
            cursor:"pointer",
            "&:hover": {
                backgroundColor: "var(--color-blue-50)"
            }, 
            "& .cell": {
                display:"table-cell", 
                whiteSpace: "nowrap",
                overflow:"hidden", 
                textOverflow:"ellipsis",
                paddingTop: theme.spacing(0.5),
                paddingBottom: theme.spacing(0.5),
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2), 
                fontSize: 14,               
            }, 
            "&.header":{
                "&:hover": {
                    backgroundColor: "inherit", 
                }, 
                fontSize: 14, 
                fontWeight: "500",
                "& .cell": {
                    color: "var(--color-neutral-900) !important",
                    borderBottom: "none !important", 
                    
                }
            },
            "& .description-cell": {
                overflow: "hidden", 
                textOverflow: "ellipsis", 
                whiteSpace:"nowrap"
            },
            "& .id-column": {
                maxWidth:"35%",
                width: "35%"
            },
            "& .star-column": {
                width: "36px",
                overflow: "visible",
                paddingLeft: 0,
                paddingRight: 0,
                textAlign: "center",
                "& svg": {
                    height: 16,
                    width:17
                }
            }, 
            "&:not(:last-child)": {
                "& .cell": {
                    borderBottomStyle: "solid", 
                    borderBottomWidth: 1, 
                    borderBottomColor: "var(--color-neutral-300)"
                }
            }
        }, 
        
    }, 
    emptyActivities : {
        position:"absolute", 
        top: "50%", 
        transform:"translate-x(-50%)", 
        width:"100%",
        left: 0,
        textAlign:"center", 
        fontSize: 18, 
        fontWeight: 400,
        lineHeight: "160%"
    }

}));
